import React from "react";
import { Stack } from "@phosphor-icons/react";
import classNames from "classnames/bind";
import { EmptyState, EmptyStateProps } from "../../EmptyState";
import styles from "./DataTableEmptyState.module.scss";

const cx = classNames.bind(styles);

export type DataTableEmptyStateProps = { isFluid?: boolean } & Partial<
  Pick<EmptyStateProps, "title" | "suggestion" | "icon" | "variant" | "action">
>;

/**
 * The DataTableEmptyState wraps EmptyState so that it can
 * include the isFluid prop applied to the parent table
 * which removes the unwanted extra padding
 */
export const DataTableEmptyState = ({
  isFluid,
  title = "There is no data to display",
  suggestion = "Please try adjusting your filters",
  action = null,
  icon,
  variant,
}: DataTableEmptyStateProps) => {
  return (
    <EmptyState
      title={title}
      suggestion={suggestion}
      icon={icon ?? <Stack />}
      variant={variant}
      className={cx("container", { isFluid })}
      action={action}
    />
  );
};
